import RequestService from "./request-service";

export default class AppointmentsService {
  static setCsrfToken(csrfToken) {
    RequestService.setCsrfTokenIfEmpty(csrfToken);
  }

  static async getAppointments(provider, treatment, start, queryString = "") {
    let url = "/Book/GetAppointments";
    if (queryString !== "") {
      url += `?${queryString}`;
    }

    let startDate = start || new Date();
    startDate = startDate.toISOString();

    return RequestService.get(url, { provider, treatmentId: treatment, start: startDate });
  }

  static async acceptBookingTerms(appointmentId) {
    const url = "/Book/AcceptTerms";

    return RequestService.post(url, { appointmentId });
  }

  static async beginBooking(appointmentId, bookingNote) {
    const url = "/Book/BeginBooking";

    return RequestService.post(url, { appointmentId, bookingNote });
  }

  static async getPaymentDetails() {
    const url = "/Book/GetPaymentDetails";

    return RequestService.get(url);
  }

  static async confirmAppointment() {
    const url = "/Book/ConfirmAppointment";

    return RequestService.post(url);
  }

  static async getBookContent() {
    const url = "/Book/Content";

    return RequestService.get(url);
  }

  static async getNavbarContent() {
    const url = "/Book/NavbarContent";

    return RequestService.get(url, { returnUrl: "/Book" });
  }

  static async getTermsContent() {
    const url = "/Book/TermsContent";

    return RequestService.get(url);
  }

  static async getLoginContent() {
    const url = "/Account/LoginContent";

    return RequestService.get(url);
  }

  static async getContent(bookingUrl) {
    let url;
    if (typeof bookingUrl === "string") {
      url = new URL(bookingUrl, document.location);
    }
    else if (bookingUrl instanceof URL) {
      url = bookingUrl;
    }
    else {
      throw new Error("bookingUrl must be a valid url string or URL object");
    }

    // Handle the root content page at /book/content 
    if (url.pathname.toLowerCase().endsWith("/book")) {
      url.pathname += "/";
    }
    else {
      // The page (action) is always the second segment ({controller}/{action})
      // So, this is the segment that needs appending, not the last one,
      // as some have an id segment on the end. E.g., /book/continue/1234567
      let parts = url.pathname.split("/");
      // part[0] will be empty because of the opening slash
      // e.g., ["", "book", "continue", "1234567"]
      parts[2] += "Content";
      url.pathname = parts.join("/");
    }

    return RequestService.get(url.toString());
  }

  static async sendAppointmentConfirmationEmail(appointmentId) {
    const url = "/Home/SendAppointmentEmail";

    return RequestService.post(
      url,
      { appointmentId }
    );
  }
}
